import firebase from "firebase";
import "firebase/firestore";

// firebase init goes here
const config = {
  apiKey: "AIzaSyAkFx3Hz1ANfbzmzN3aHF62S6VwF5aua9U",
  authDomain: "shopping-time-97f96.firebaseapp.com",
  databaseURL: "https://shopping-time-97f96.firebaseio.com",
  projectId: "shopping-time-97f96",
  storageBucket: "shopping-time-97f96.appspot.com",
  messagingSenderId: "582596761680",
  appId: "1:582596761680:web:23a18dd178e97d7a051955",
  measurementId: "G-K286B9QRV5"
};
firebase.initializeApp(config);
firebase.analytics();
const messaging = firebase.messaging();
messaging.usePublicVapidKey(
  "BJi63tvGg_IJo8HcmzOvrAVolKBbZFoodU3xL6aH3KdeOdeDTQUAwPWd3VwM3rl-U-qsMtL4OufV3gtloGdOgjQ"
);
navigator.serviceWorker
  .register("/firebase-messaging-sw.js")
  .then(registration => {
    messaging.useServiceWorker(registration);
  })
  .catch(err => {
    console.log(err);
  });
// firebase utils
const db = firebase.firestore();
if (location.hostname === "localhost") {
  db.settings({
    host: "localhost:5005",
    ssl: false
  });
}
const auth = firebase.auth();
const currentUser = auth.currentUser;

// firebase collections
const usersCollection = db.collection("users");
const listItemsCategoriesCollection = db.collection("listItemsCategories");
const listsCollection = db.collection("lists");
const userListsCollection = db.collection("userLists");
const listItemsCollection = db.collection("listItems");
const distinctListItemsCollection = db.collection("distinctListItems");
const pendingListInvitesCollection = db.collection("pendingListInvites");

export {
  messaging,
  db,
  auth,
  currentUser,
  usersCollection,
  listsCollection,
  userListsCollection,
  listItemsCollection,
  distinctListItemsCollection,
  pendingListInvitesCollection,
  listItemsCategoriesCollection
};
